/**
 * Relative URL builders for field mapping API endpoints.
 * Used by fieldMappingService with http.innerSendAuthenticated.
 */

export const getFieldMappingRelativeBaseUrl = (
  orgFprint: string,
  projectId: number | string,
): string =>
  `/clients/api/v1/org/${orgFprint}/project/${projectId}/field-mappings/`;

export const getFieldMappingRelativeUrl = (
  orgFprint: string,
  projectId: number | string,
  mappingId: number,
): string =>
  `${getFieldMappingRelativeBaseUrl(orgFprint, projectId)}${mappingId}/`;

export const getSourceFieldsRelativeUrl = (
  orgFprint: string,
  projectId: number | string,
): string =>
  `${getFieldMappingRelativeBaseUrl(orgFprint, projectId)}source-fields/`;

export const getBulkApproveRelativeUrl = (
  orgFprint: string,
  projectId: number | string,
): string =>
  `${getFieldMappingRelativeBaseUrl(orgFprint, projectId)}bulk-approve/`;

export const getDeleteBySourceAttributeRelativeUrl = (
  orgFprint: string,
  projectId: number | string,
): string =>
  `${getFieldMappingRelativeBaseUrl(orgFprint, projectId)}by-source-attribute/`;

export const getFieldMappingOverrideRelativeUrl = (orgFprint: string): string =>
  `/clients/api/v1/org/${orgFprint}/field-mappings/override/`;

export const getFieldMappingSnapshotRelativeUrl = (
  orgFprint: string,
  projectId: number | string,
): string => `${getFieldMappingRelativeBaseUrl(orgFprint, projectId)}snapshot/`;

export const getCoreFieldModifiedRelativeUrl = (orgFprint: string): string =>
  `/clients/api/v1/org/${orgFprint}/core-field-modified/`;
